import {ChangeDetectorRef, Component, HostBinding, OnInit, ViewEncapsulation} from '@angular/core';
import {ClimateService, MetaService, NumericalWeatherService, SharedService, StationsService} from './../../../services';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {BreakpointObserver} from '@angular/cdk/layout';

@Component({
  selector: 'forecast-widget',
  templateUrl: './forecast-weather.component.html',
  styleUrls: ['./forecast-weather.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ForecastWeatherComponent implements OnInit {

  constructor(
    private _climate: ClimateService,
    private _numWeather: NumericalWeatherService,
    private _stations: StationsService,
    private titleService: Title,
    private _meta: MetaService,
    private _shared: SharedService,
    private cdr: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver,
    private _router: Router,
    private route: ActivatedRoute,
  ) { }

  cssMedia = 'screen and (max-width: calc(1024px + 20px))';
  isTablet;
  layoutChanges = this.breakpointObserver.observe([this.cssMedia]);
  isMobileAds = this.breakpointObserver.isMatched('screen and (max-width: 788px)');
  isSmallMobile = this.breakpointObserver.isMatched('screen and (max-width: 500px)');
  isTabletAds = this.breakpointObserver.isMatched('screen and (max-width: 1044px)');
  isSmallHeader = this.breakpointObserver.isMatched('screen and (max-width: 1000px)');
  heightHeaderBig = '28px - 49px';
  heightHeaderSmall = '64px';

  contentMinHeight;
  haveFactWidget;
  haveStorm;
  haveHydroStorm;
  footerHeight;

  private routeSub: Subscription;
  private sharedCitySub: Subscription;
  router: Router;

  firstInitTimezone = true;
  firstInitCity = true;

  loading = false;

  result;
  listDays;
  listHours6Day1 = [0, 12];
  listHours6Day2 = [24, 36];
  listHours6Day3 = [48, 60];
  listHours6Day4 = [72, 84];
  listHours6Day5 = [96, 108];
  listHours6Day6 = [120, 132];
  listHours6 = [
    this.listHours6Day1,
    this.listHours6Day2,
    this.listHours6Day3,
    this.listHours6Day4,
    this.listHours6Day5,
    this.listHours6Day6
  ];

  selectedFromUrl;
  selectedFromUrlName;
  urlCityForChange;
  selectedCity;
  timeUTC = false;
  cities = [];



  noData12 = false;
  canIuseGet12 = true;
  subscribeNumWeather: Subscription;
  listDays2 = [];
  originalData = [];
  result2;
  mergedObject = [];
  combinedObject;

  subscribeLayout: Subscription;

  checkTimeOfDay(h) {
    if ((h >= 0 && h <= 5) || (h >= 18 && h <= 24)) {
      return 'night';
    } else if (h >= 6 && h <= 17) {
      return 'day';
    }
    return 'day';
  }

  getPRESSURE_MODIF(num) {
    if (num === 0) {
      return 'не измен.';
    } else if (num === 1) {
      return 'растёт';
    } else if (num === 2) {
      return 'падает';
    }
    return '';
  }
  getDirection(dir) {
    if (dir < 0) {dir = dir + 360; }
    if (dir > 360) {dir = dir - 360; }
    if (dir >= 0 && dir < 22.5) { return 'С'; }
    if (dir >= 22.5 && dir < 67.5) { return 'С-В'; }
    if (dir >= 67.5 && dir < 112.5) { return 'В'; }
    if (dir >= 112.5 && dir < 157.5) { return 'Ю-В'; }
    if (dir >= 157.5 && dir < 202.5) { return 'Ю'; }
    if (dir >= 202.5 && dir < 247.5) { return 'Ю-З'; }
    if (dir >= 247.5 && dir < 292.5) { return 'З'; }
    if (dir >= 292.5 && dir < 337.5) { return 'С-З'; }
    if (dir >= 337.5 ) { return 'С'; }
  }
  getTuman(n) {
    if (n == 0) { return ''; }
    if (n == 1) { return 'Слабый туман'; }
    if (n == 2) { return 'Умеренный туман'; }
    return '';
  }
  getGololed(n) {
    if (n == 0) { return ''; }
    if (n == 1) { return 'Слабый гололёд'; }
    if (n == 2) { return 'Умеренный гололёд'; }
    return '';
  }
  getGroza(n) {
    if (n > 0) { return `Вероятность грозы ${n}%`; }
    return '';
  }
  concatDangerous(arr) {
    return arr.filter(v => v != '').join(', ');
  }
  roundTemp(t) {
    if (t < 0) {
      return -1 * Math.round(Math.abs(t));
    } else {
      return Math.round(t);
    }
  }

  checkDayIsNotOver(dd) {
    if (this.timeUTC) {
      const t = Number(dd);
      const year = new Date(t).getUTCFullYear() >= new Date().getUTCFullYear();
      const month = new Date(t).getUTCMonth() >= new Date().getUTCMonth();
      const day = new Date(t).getUTCDate() >= new Date().getUTCDate();
      // return year && month && day;
      if (new Date(t).getUTCFullYear() > new Date().getUTCFullYear()) { return true; } else if (new Date(t).getUTCMonth() > new Date().getUTCMonth()) { return true; } else if (new Date(t).getUTCDate() > new Date().getUTCDate()) { return true; } else { return year && month && day && (new Date().getUTCHours() <= 21); }

    } else {
      const t = Number(dd);
      // console.log('t: ', new Date(t), ' ', 'new Date: ', new Date());
      const year = new Date(t).getUTCFullYear() >= new Date().getUTCFullYear();
      const month = new Date(t).getUTCMonth() >= new Date().getUTCMonth();
      const day = new Date(t).getUTCDate() >= new Date().getUTCDate();
      // return year && month && day;
      if (new Date(t).getUTCFullYear() > new Date().getUTCFullYear()) { return true; } else if (new Date(t).getUTCMonth() > new Date().getUTCMonth()) { return true; } else if (new Date(t).getUTCDate() > new Date().getUTCDate()) { return true; } else { return year && month && day && (new Date().getUTCHours() <= (21 - this.selectedCity.timezone)); }
    }
  }

  parsePlus(t) {
    t = this.roundTemp(t);
    return t > 0 ? '+' + t : t;
  }
  getUIableTemperature(min, max) {
    min = this.roundTemp(min);
    max = this.roundTemp(max);
    const htmlMIN = `<span class="${min <= 0 ? 'min' : 'max'}">${this.parsePlus(min)}</span>`;
    const htmlMAX = `<span class="${max <= 0 ? 'min' : 'max'}">${this.parsePlus(max)}</span>`;

    return `${htmlMIN}..${htmlMAX}`;
  }
  getTimezone() {
    return this.timeUTC ? '+0' : (this.selectedCity.timezone < 0 ? '' + this.selectedCity.timezone : '+' + this.selectedCity.timezone);
  }

  get12(tmp?) {
    this.canIuseGet12 = false;
    setTimeout(() => this.canIuseGet12 = true, 1000);
    this.loading = true;
    this.subscribeNumWeather = this._numWeather.get12(
      this.selectedCity.id
    ).subscribe(
      async res => {
        this.result = res;
        this.listDays = Object.keys(this.result);
        if (this.listDays && this.listDays.length && this.listDays.length > 0) {
          const rrr = {};
          const zero = this.listDays[0];
          Object.keys(this.result[zero]).forEach(v => {
            const day = (new Date(zero)).setUTCDate((new Date(zero)).getUTCDate() + Math.floor((Number(v)) / 24));
            if (!rrr[day]) {
              rrr[day] = [];
            }
            if (res[zero] && res[zero][Number(v)]) {
              const item = res[zero][Number(v)];
              item.ADVANCE_TIME = item.ADVANCE_TIME;
              rrr[day].push(item);
            }
          });

          this.originalData = Object.keys(rrr);

          Object.keys(rrr).forEach(day => {
            if (rrr[day].length === 1) {
              delete rrr[day];
            }
          });

          this.result2 = rrr;
          this.listDays2 = Object.keys(this.result2);

          function mergeObjectsByIndex(result: any): any {
            const mergedResult = {};
            // @ts-ignore
            Object.keys(result).forEach(key => {
            // @ts-ignore
              if (result[key] && result[key].length >= 2) {
              // @ts-ignore
              const obj1 = result[key][0];
              // @ts-ignore
              const obj2 = result[key][1];

              mergedResult[key] = [{
                ccc: obj1.ccc,
                DATES: obj1.DATES,
                CITY_ID: obj1.CITY_ID,
                ADVANCE_TIME: obj2.ADVANCE_TIME,
                ID_WEATHER: obj2.ID_WEATHER,
                GOLOLED: Math.max(obj1.GOLOLED, obj2.GOLOLED),
                GROZA: Math.max(obj1.GROZA, obj2.GROZA),
                GUST: Math.max(obj1.GUST, obj2.GUST),
                PRECIP: Math.round((obj1.PRECIP + obj2.PRECIP) * 10) / 10,
                PRESSURE_MAX: Math.max(obj1.PRESSURE_MIN, obj2.PRESSURE_MIN, obj1.PRESSURE_MAX, obj2.PRESSURE_MAX),
                PRESSURE_MIN: Math.min(obj1.PRESSURE_MIN, obj2.PRESSURE_MIN, obj1.PRESSURE_MAX, obj2.PRESSURE_MAX),
                PRESSURE_MODIF: obj2.PRESSURE_MODIF,
                RH_MAX: Math.max(obj1.RH_MIN, obj2.RH_MIN, obj1.RH_MAX, obj2.RH_MAX),
                RH_MIN: Math.min(obj1.RH_MIN, obj2.RH_MIN, obj1.RH_MAX, obj2.RH_MAX),
                // SNOW: ,
                // TMP: ,
                TMP_MAX: Math.max(obj2.TMP_MIN, obj2.TMP_MAX),
                TMP_MIN: Math.min(obj1.TMP_MIN, obj1.TMP_MAX),
                TUMAN: Math.max(obj1.TUMAN, obj2.TUMAN),
                TypeWeather: obj2.TypeWeather,
                TypeWeather_by: obj2.TypeWeather_by,
                VIS: obj2.VIS,
                WINDDIR: obj2.WINDDIR,
                WINDSP_MAX: Math.max(obj1.WINDSP_MIN, obj2.WINDSP_MIN, obj1.WINDSP_MAX, obj2.WINDSP_MAX),
                WINDSP_MIN: Math.min(obj1.WINDSP_MIN, obj2.WINDSP_MIN, obj1.WINDSP_MAX, obj2.WINDSP_MAX),
                ww: obj2.ww
              }];
            }
              });
            return mergedResult;
          }
          const mergedObject = mergeObjectsByIndex(this.result2);

          // Достаем только первый день
          const slicedData = {[this.listDays2[0]]: mergedObject[this.listDays2[0]]} as any;
          this.mergedObject = slicedData;
          this.noData12 = false;

        } else {
          this.noData12 = true;
        }
        this.loading = false;
      },
      err => {
        console.error(err);
        this.noData12 = true;
        this.loading = false;
      }
    );
  }
  ngAfterViewInit() {
    this._shared.currentFooterHeight.subscribe(state => {
      this.contentMinHeight = `calc(100% - ${state}px)`;
      this.isMobileAds = this.breakpointObserver.isMatched('screen and (max-width: 788px)');
      this.isSmallHeader = this.breakpointObserver.isMatched('screen and (max-width: 1000px)');
    });
    this.subscribeLayout = this.layoutChanges.subscribe(result => {
      // this._shared.changeFooterHeight(this.el.nativeElement.offsetHeight);
      this.isMobileAds = this.breakpointObserver.isMatched('screen and (max-width: 788px)');
      this.isSmallMobile = this.breakpointObserver.isMatched('screen and (max-width: 500px)');
      this.isTablet = result.breakpoints[this.cssMedia];
      this.isTabletAds = this.breakpointObserver.isMatched('screen and (max-width: 1044px)');
    });
    this.cdr.detectChanges();
  }

  ngOnInit() {
    // this._meta.update(this.route.snapshot.data);
    this.routeSub = this.route.params.subscribe(params => {
      // console.log(params)
      this._shared.currentCity.subscribe(city => {
        this.selectedCity = city;
        this.get12(1);
      });
    });

    this._shared.currentStorm.subscribe(state => {
      this.haveStorm = state;
      const minusHeight = this.isSmallHeader ? this.heightHeaderSmall : this.heightHeaderBig;
      const minusStorm = this.haveStorm ? '- 40px' : '';
      const minusHydroStorm = this.haveHydroStorm ? '- 40px' : '';
      // this.height = `calc(100vh - ${minusHeight} ${minusStorm} ${minusHydroStorm})`;
      // this.paddingTop = '0px';
      // this.height = `calc(100vh - 71px - 50px ${this.haveStorm ? '- 40px' : ''}
      // ${this.haveHydroStorm ? '- 40px' : ''})`;
    });
    this._shared.currentHydroStorm.subscribe(state => {
      this.haveHydroStorm = state;
      const minusHeight = this.isSmallHeader ? this.heightHeaderSmall : this.heightHeaderBig;
      const minusStorm = this.haveStorm ? '- 40px' : '';
      const minusHydroStorm = this.haveHydroStorm ? '- 40px' : '';
      // this.height = `calc(100vh - ${minusHeight} ${minusStorm} ${minusHydroStorm})`;
      // this.paddingTop = this.isSmallHeader ? `${64 + (this.haveStorm ? 40 : 0) + (this.haveHydroStorm ? 40 : 0)}px` : '0px';
      // this.height = `calc(100vh - 71px - 50px ${this.haveStorm ? '- 40px' : ''}
      //  ${this.haveHydroStorm ? '- 40px' : ''})`;
    });
    this._shared.currentTime.subscribe(time => {
      this.timeUTC = time;
      // console.log(!this.timeUTC ? ((this.selectedCity && isFinite(this.selectedCity.timezone)) ? this.selectedCity.timezone : 3) : 0);

      !this.firstInitTimezone && this.get12(4);
      this.firstInitTimezone = false;
    });
    this._shared.currentFactWidget.subscribe(state => {
      this.haveFactWidget = state;
    });
  }

  getNumWeather2Url(): string {
    return '/weather/numerical-weather-2' + (this.selectedCity ? '/' + this.selectedCity.id : '');
  }

  getNumWeather12Url(): string {
    return '/weather/numerical-weather-day' + (this.selectedCity ? '/' + this.selectedCity.id : '');
  }

  getNumWeather6Url(): string {
    return '/weather/numerical-weather-6' + (this.selectedCity ? '/' + this.selectedCity.id : '');
  }

  getSynopticWeather(): string {
    return '/weather/synoptic';
  }

  ngOnDestroy() {
    this.listDays = null;
    this.listDays2 = null;
    this.result = null;
    this.result2 = null;
    this.subscribeNumWeather && this.subscribeNumWeather.unsubscribe();
    this.routeSub && this.routeSub.unsubscribe();
    this.sharedCitySub && this.sharedCitySub.unsubscribe();
    this.subscribeLayout && this.subscribeLayout.unsubscribe();
  }

}
